import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

//import components
import ItemText from '../../ItemText.js';
import ItemNested from '../../ItemNested.js';
import ItemSubSection from '../../ItemSubSection.js';
import ItemSubSection2 from '../../ItemSubSection2.js';
import ItemSubSectionSeparate from '../../ItemSubSectionSeparate.js';
import ItemSubSectionSeparate2 from '../../ItemSubSectionSeparate2.js';
import ItemListSeparate from '../../ItemListSeparate.js';
import ItemListInline from '../../ItemListInline.js';
import ItemInText from '../../ItemInText.js';

const RecordSection = ({clang, text, label, data, type}) => {
    const getDataItem = (item, index) => {
        let component;

        switch(item.label) {
            case 'titleOriginalLang':
            case 'translationBaseLang':
            case 'editionYear':
            case 'annotations':
            case 'edition':
            case 'physicalDescription':
            case 'publicationLanguage':
            case 'chapterTitle':
            case 'partTitle':
            case 'pagesRange':
                component = <ItemText text={item.val}/>;
                break;
            case 'author':
            case 'journal':
            case 'source':
            case 'journal-number':
            case 'theater':
                component = <ItemText text={item.val.label} link={item.val.link} type={item.val.entityType}/>;
                break;
            case 'premiereYear':
            case 'radioType':
            case 'televisionType':
            case 'publicationYear':
                component = <ItemText text={item.val.label} link={item.val.link}/>;
                break;
            case 'belongingpublishingSeries':
                component = <div>
                                {item.val.series ?
                                    <div>
                                        <ItemListSeparate list={[item.val.series]}/>
                                    </div>
                                    : false}
                                {item.val.subseries ?
                                    <div>
                                        <ItemListSeparate list={[item.val.subseries]}/>
                                    </div>
                                    : false}
                            </div>;
                break;
            case 'authorCompany':
                component = <ItemListInline list={item.val} type='authorCompany'/>;
                break;
            case 'countries':
            case 'types':
            case 'typesAndKind':
                component = <ItemListInline list={item.val} />;
                break;
            case 'parent':
                component = <ItemInText list={[item.val]} />;
                break;
            case 'contents':
                component = <ItemInText list={item.val} />;
                break;
            case 'productionYear':
                component = <div><ItemText text={item.val.label} link={item.val.link} type={item.val.entityType}/><ItemText text={item.val.description} /></div>
                break;
            case 'headings':
            case 'secondaryHeadings':
                component = item.val.map((itemVal, index) => {
                              const domain = itemVal.filter(listItem => listItem.entityType === 'domain')[0];
                              const newList = itemVal.filter(listItem => listItem.entityType !== 'domain');

                              return domain && newList ?
                                        <ItemNested list={newList} domain={domain} key={index} type={item.label}/>
                                        : false;
                            });
                break;
            case 'linkedFilesAndRecords':
            case 'relatedFilesAndRecords':
                component = <ItemSubSection list={item.val} seeMore={item.label === "linkedFilesAndRecords"}/>;
                break;
            case 'coCreators':
                component = <ItemSubSection2 list={item.val} />;
                break;
            case 'anthologyDesc':
            case 'mailingParts':
            case 'interviewParts':
                component = <ItemSubSectionSeparate desc={item.val.desc} items={item.val.items}/>;
                break;
            case 'resumptions':
                component = <ItemSubSectionSeparate2 list={item.val}/>;
                break;
            case 'premiere':
                component = <ItemSubSectionSeparate2 list={[item.val]}/>;
                break;
            case 'title':
            case 'incipitTitle':
            case 'incipit':
            case 'titleOriginal':
            case 'translationBase':
            case 'dedication':
                component = <ItemText text={item.val.label} isTransit={item.val.transliterated}/>;
                break;
            case 'producersAndFilmStudios':
                const types = item.val.filter(listItem => !listItem.entityType);
                const makers = item.val.filter(listItem => listItem.entityType);

                component = <ItemListSeparate list={makers} types={types}/>;
                break;
            case 'creative-work':
            case 'triggerInstitutions':
            case 'locations':
            case 'publishingHouses':
            case 'collections':
            case 'authors':
            case 'belongingToSeries':
            case 'partDedication':
            case 'sourceOrigin':
                component = <ItemListSeparate list={item.val}/>;
                break;
            default:
                break;
        }

        switch(label) {
            case 'external_links':
              component = <div><ItemText text={item.val.label} link={item.val.link} newTab={true}/><ItemText text={item.val.desc} type="externalLinks"/></div>
              break;
            default:
              break;
        }

        return component ?
                  <div className="record__section__data-item" key={index}>
                          <label className="record__section__data-label">
                            {item.label !== 'relatedFilesAndRecords' ?
                              lang[clang].item.record[item.label] ?
                                  <span>{lang[clang].item.record[item.label]}:</span>
                                  : <span>{item.label}:</span>
                              : ''}
                          </label>
                      <div className="record__section__data-container">
                          {component}
                      </div>
                  </div>
                  : false;
    };

    return (
        <div className="record__section">
            <h4 className="record__section-label" dangerouslySetInnerHTML={{__html: lang[clang].item[label]}}></h4>
            <div className="record__section__data">
                {data.map((dataItem, index) => getDataItem(dataItem, index))}
            </div>
        </div>
    );
};

RecordSection.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(RecordSection);



// WEBPACK FOOTER //
// ./src/components/items/records/common/RecordSection.js